import { useEffect, useState } from "react";
import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "@/pages/home/components/Hero";
import FilmProfile from "@/pages/home/components/FilmProfile";
import PlotSection from "@/pages/home/components/PlotSection";
import CharactersSection from "@/pages/home/components/CharactersSection";
import CastSection from "@/pages/home/components/CastSection";
import CommentarySection from "@/pages/home/components/CommentarySection";
import ThemesSection from "@/pages/home/components/ThemesSection";
import ReviewsSection from "@/pages/home/components/ReviewsSection";
import RelatedSection from "@/pages/home/components/RelatedSection";
import FaqSection from "@/pages/home/components/FaqSection";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 900);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <FilmProfile />
        <PlotSection />
        <CharactersSection />
        <CastSection />
        <CommentarySection />
        <ThemesSection />
        <ReviewsSection />
        <RelatedSection />
        <FaqSection />
      </main>
      <SiteFooter />

      {showTop ? (
        <button
          type="button"
          onClick={backToTop}
          className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl shadow-md hover:bg-primary-600 transition-colors cursor-pointer"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}